<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view v-if='isRouterAlive'/>
  </div>
</template>

<script>
import storage from '@/utils/storage'
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true
    }
  },
  methods:{
    reload(){
      this.isRouterAlive=false;
      this.$nextTick(function(){
        this.isRouterAlive=true;
      })
    }
  },
   created (){
    var self = this;  
    window.onload = function() {
      document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
        })
        document.addEventListener('gesturestart', function(event) {
          event.preventDefault()
        })
     }
  },
}

</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  height:100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue